import React from 'react';
import { Card } from './card';
import { ReactComponent as WarningIcon } from './../../../assets/icons/warning.svg';
import { css } from '../../../services/css';


import styles from './archivedUserCard.module.css';
import { Button } from '../inputs/button';

export const ArchivedUserCard = () => {
    return <Card
        className={css(styles.Card, styles.ArchivedUserCard)}
        title='This user is archived which means they were most likely removed the Azure AD. Users are archived instead of being deleted to keep better audit records and prevent from links breaking.'
    >
        <div className='icon text-color'>
            <WarningIcon />
        </div>
        User is archived
        {/* <Button className={css('icon', 'text-color', styles.Info)}>
            <InfoIcon />
        </Button> */}
    </Card>;
}